import { NavigateFunction, Location as ReactLocation } from "react-router-dom";

export class FotProcessUIParam {
  setBrowerSuggestionTip?: (isShare: boolean) => void;
  navigate?: NavigateFunction;

  constructor(
    public localLocation: ReactLocation,
    public location: Location,
    public history: History,
    public sessionStorage: Storage
  ) {}
}
